import type { Message } from "@hz/common/api-types/index";
import type { GetUserResponse, GetUsersPermissionsResponse } from "@hz/common/api-types/user";

import { api, Tags } from "@state/apiSlice";

import type { GetUserPermissionParams, UpdateUsersPermissionsParams } from "./types";

const userRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getUser: build.query<GetUserResponse, GetUserPermissionParams>({
      query: () => ({
        url: "/users/me/permissions",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getUsersPermissions: build.query<GetUsersPermissionsResponse, void>({
      query: (data) => ({
        url: "/users/permissions",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      }),
      providesTags: [{ type: Tags.Permissions }],
    }),
    updateUsersPermissions: build.mutation<Message, UpdateUsersPermissionsParams>({
      query: (data) => ({
        url: "/users/permissions",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: [{ type: Tags.Permissions }],
    }),
  }),
});

export default userRequestsSlice;
